import { __awaiter, __decorate, __extends, __generator } from "tslib";
import NavPanel from '@/components/common/NavPanel.vue';
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import NavSelect from '@/components/assist/navSelect.vue';
import { PageService } from '@/views/copy/invite/import';
import Backpack from '@/views/copy/mall/page/Backpack.vue';
import AvalonGTGlobal from '@/utils/factory/Global';
import moment from 'moment';
import { Toast } from 'vant';
import { gsap } from 'gsap';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportList = [];
        _this.loading = true; //@ 2021/12/22 14:27 是否加载
        _this.finished = false; //@ 2021/12/22 14:28 是否已加载完成，完成后不再出发load事件
        _this.deriveLoading = false; //  2024-01-17 11:14:02：导出中
        _this.pageIndex = 1; //@ 2021/12/21 17:32 分页的页数
        _this.selectModel = 0; // 2023/10/18 9:48  选中的内容
        _this.lastId = 0; // 2023/10/29 16:49 列表最后一个id
        _this.selectActive = 0;
        _this.params = {};
        _this.enableBtn = false; // 2023/12/19 13:16  是否隐藏导出按钮
        _this.downloadUrl = ''; // 下载链接
        _this.calendarShow = false;
        _this.tiemr = '';
        _this.iscalendarType = 'range';
        _this.singleTiem = '';
        return _this;
    }
    View.prototype.mounted = function () {
        this.params = this.$route.query;
        this.params.startDate = moment().subtract(38, 'day').format('YYYY-MM-DD');
        this.params.endDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
        this.params.minDate = new Date(this.params.startDate);
        this.params.maxDate = new Date(this.params.endDate);
        this.singleTiem = this.params.startDate;
        this.getList();
        // this.getDownloadUrl();
        // localStorage.setItem('inviteTabIndex', '2');
    };
    View.prototype.beforeDestroy = function () {
        clearTimeout(this.tiemr);
    };
    //  2024-04-30 16:29:00：联系客服
    View.prototype.linkService = function () {
        this.awlGlobalConfig.gotoKfService();
    };
    //@ 2021/12/22 14:26 加载数据
    View.prototype.onLoad = function (val) {
        console.log('onLoad');
        this.loading = true;
        this.finished = false;
        this.pageIndex++;
        //@ 2021/12/22 17:22 请求接口
        this.getList();
    };
    View.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.deriveLoading)
                            return [2 /*return*/, Toast('导出中...')];
                        gsap.fromTo('.refresh', {
                            rotation: 0,
                        }, {
                            rotation: 360,
                            duration: 5,
                            ease: 'elastic',
                        });
                        return [4 /*yield*/, this.getList()];
                    case 1:
                        _a.sent();
                        Toast('刷新成功~');
                        return [2 /*return*/];
                }
            });
        });
    };
    View.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.exportRecord({})];
                    case 1:
                        data = _a.sent();
                        this.reportList = data.list;
                        return [2 /*return*/];
                }
            });
        });
    };
    View.prototype.selectHandle = function (val) {
        this.selectActive = val;
        this.lastId = 0;
        this.loading = true;
        this.finished = false;
        this.getList();
    };
    View.prototype.getDownloadUrl = function () {
        var _this = this;
        if (this.deriveLoading)
            return Toast('导出中...');
        // this.loading = true;
        this.deriveLoading = true;
        var params = {
            startDate: this.params.startDate,
            endDate: this.params.endDate,
        };
        if (this.iscalendarType === 'single') {
            params.startDate = this.singleTiem;
            params.endDate = this.singleTiem;
        }
        PageService.exportInviteExcel(params)
            .then(function (data) {
            // this.loading = false;
            _this.getList();
            _this.tiemr = setTimeout(function () {
                _this.getList();
                _this.deriveLoading = false;
            }, 3000);
            // this.downloadUrl = data.url;
        })
            .catch(function () {
            _this.deriveLoading = false;
        });
    };
    View.prototype.toBack = function () {
        this.$router.go(-1);
    };
    View.prototype.exportExcel = function () {
        AvalonGTGlobal.copyText(this.downloadUrl.toString(), '快去浏览器下载吧');
    };
    View.prototype.dateShowHandle = function () {
        this.calendarShow = true;
    };
    View.prototype.onCalendarConfirm = function (values) {
        console.log('确认时间：', values);
        //  2024-05-09 12:10:05：范围时间
        if (this.iscalendarType === 'range') {
            var startDate = moment(values[0]).format('YYYY-MM-DD');
            var endDate = moment(values[1]).format('YYYY-MM-DD');
            this.params.endDate = endDate;
            this.params.startDate = startDate;
        }
        else {
            //  2024-05-09 12:10:14：单天时间
            this.singleTiem = moment(values).format('YYYY-MM-DD');
        }
        this.calendarShow = false;
        // this.getList()
    };
    View.prototype.copyHandle = function (val) {
        console.log('val', val);
        AvalonGTGlobal.copyText(val);
    };
    View = __decorate([
        Options({
            name: 'reportRecord',
            components: { Backpack: Backpack, NavSelect: NavSelect, NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
